import React from 'react';
import PropTypes from 'prop-types';

const inverseOfOrder = {
  'asc': 'desc',
  'desc': 'asc'
};

function Header({
  onChange: _onChange,
  values = [],
  title,
  selected = {},
  thProps = {},
  revert = false,
  miniLabels = {},
  disabled = false
}) {
  const selectedValue = Object.keys(selected)[0];
  const nextValue = values[values.indexOf(selectedValue) + 1] || values[0];
  const comparator = revert ? 'desc' : 'asc';
  const isSelected = values.indexOf(selectedValue) != -1;
  const value = (comparator != selected[selectedValue]) ? nextValue : isSelected ? selectedValue : nextValue ;
  const order = value == selectedValue ? inverseOfOrder[selected[selectedValue]] : comparator;
  const onChange = disabled ? () => {} : _onChange;
  return (
    <th onClick={() => onChange(value, order) }
        style={disabled ? { cursor: 'not-allowed' } : {}}
        {...thProps}>
      {title}
      { isSelected &&
        <span>
          {values.length > 1 && miniLabels[selectedValue]}
          <i className="material-icons">{selected[selectedValue] == comparator ? 'arrow_drop_down' : 'arrow_drop_up'}</i>
        </span>
      }
    </th>
  );
}

Header.defaultProps = {};

Header.propTypes = {};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Admin/shared/Table/Header.jsx